import AdsError from './AdsError.js'

export default class GetSearchResultsError extends AdsError {}
